import React from 'react'

const Soon = () => {
  return (
    <div>
        <h1 style={{color: "white", margin: "90px"}}>
            Coming Soon...
        </h1>
    </div>
  )
}

export default Soon